var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.481 13.86a4.535 4.535 0 00-3.413-1.543c-1.411 0-2.66.627-3.494 1.636M6.417 11.483a6.82 6.82 0 015.651-2.94c2.289 0 4.28 1.065 5.536 2.781",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32 9.058C6.04 6.596 8.836 5.07 12.068 5.07c3.14 0 5.878 1.458 7.612 3.802",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.289 16.965a1.293 1.293 0 11-2.587 0 1.293 1.293 0 012.587 0z",
    fill: "#666"
  })))));
}
export default SvgFreeWifi;